<fui-podium>
    <ng-content></ng-content>
</fui-podium>
